import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private SupplierOrderPositionReceived Types */
import {
  _SupplierOrderPositionReceived
} from '../namespace-helper'

import _ from 'lodash'

const selectedSupplierOrderPositionReceivedTemplate = {
  id: 0,
  manufacturer: {
    name: null
  },
  suppliers_orders_position: {
    suppliers_order: {
      supplier: {
        name: null
      }
    }
  }

}
export default {
  namespaced: true,
  state: {
    selectedSupplierOrderPositionReceived: _.cloneDeep(selectedSupplierOrderPositionReceivedTemplate),
    supplierOrderPositionsReceived: [],
    supplierOrderPositionReceivedLoading: false,
    supplierOrderPositionReceivedRemoving: false,
    openDialog: false
  },
  mutations: {
    [_SupplierOrderPositionReceived.mutations.setSelectedSupplierOrderPositionReceived] (state, payload) {
      if (payload !== null) {
        state.selectedSupplierOrderPositionReceived = payload
      } else {
        state.selectedSupplierOrderPositionReceived = _.cloneDeep(selectedSupplierOrderPositionReceivedTemplate)
      }
    },
    [_SupplierOrderPositionReceived.mutations.setSupplierOrderPositionsReceived] (state, payload) {
      state.supplierOrderPositionsReceived = payload
    },
    [_SupplierOrderPositionReceived.mutations.setRemovingSupplierOrderPositionReceived] (state, payload) {
      state.supplierOrderPositionReceivedRemoving = payload
    },
    [_SupplierOrderPositionReceived.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    }
  },
  actions: {
    [_SupplierOrderPositionReceived.actions.saveSupplierOrderPositionReceived] (context, payload) {
      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/supplierOrderPositionReceived'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/supplierOrderPositionReceived/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_SupplierOrderPositionReceived.actions.saveSupplierOrderPositionReceivedClaim] (context, payload) {
      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/sopReceivedClaims'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/sopReceivedClaims/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_SupplierOrderPositionReceived.actions.loadSupplierOrderPositionReceivedForPosition] (context, payload) {
      var url = API_URL + '/api/v1/supplierOrderPositionReceived/supplierOrderPosition/' + payload.id

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          context.commit(_SupplierOrderPositionReceived.mutations.setSupplierOrderPositionsReceived, r.data.data)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOrderPositionReceived.mutations.setSupplierOrderPositionsReceived, [])
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrderPositionReceived.actions.deleteSupplierOrderPositionReceived] (context, payload) {
      context.commit(_SupplierOrderPositionReceived.mutations.setRemovingSupplierOrderPositionReceived, true)

      var url = API_URL + '/api/v1/supplierOrderPositionReceived/' + payload.id

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_SupplierOrderPositionReceived.mutations.setRemovingSupplierOrderPositionReceived, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOrderPositionReceived.mutations.setRemovingSupplierOrderPositionReceived, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrderPositionReceived.actions.setSelectedSupplierOrderPositionReceived] (context, payload) {
      context.commit(_SupplierOrderPositionReceived.mutations.setSelectedSupplierOrderPositionReceived, payload)
    },
    [_SupplierOrderPositionReceived.actions.openCloseDialog] ({ commit }) {
      commit(_SupplierOrderPositionReceived.mutations.setOpenCloseDialogState)
    },
    [_SupplierOrderPositionReceived.actions.resetState] ({ commit }) {
      commit(_SupplierOrderPositionReceived.mutations.setSupplierOrderPositionsReceived, [])
      commit(_SupplierOrderPositionReceived.mutations.setSelectedSupplierOrderPositionReceived, null)
    }

  },
  getters: {
    [_SupplierOrderPositionReceived.getters.supplierOrderPositionsReceived] (state) {
      return state.supplierOrderPositionsReceived
    },
    [_SupplierOrderPositionReceived.getters.getSelectedSupplierOrderPositionReceived] (state) {
      return state.selectedSupplierOrderPositionReceived
    },
    [_SupplierOrderPositionReceived.getters.getOpenDialogState] (state) {
      return state.openDialog
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/SupplierOrderPositionsReceived/supplierOrderPositionsReceived.js